export default __webpack_public_path__ + "static/media/nuclea.6de55ebe.png";